export default __webpack_public_path__ + "static/media/pc06-6-1.136a25af.png";